import React from 'react';
import s from './PoliticsFooter.scss';
import { LinkWrapper } from '../../components/BaseComp';

export const PoliticsFooter = () => {
    return (
        <div className={s.box}>
            <div className={s.gallery}>
                <LinkWrapper className={s.item} href="http://www.12377.cn/">
                    <div>
                        <img className={s.image} src="//statics.itc.cn/web/v3/static/images/pic/service/pic02.gif" alt="" />
                    </div>
                    <p className={s.label}>中国互联网<br />举报中心</p>
                </LinkWrapper>
                <LinkWrapper className={s.item} href="http://www.bjjubao.org/">
                    <div>
                        <img className={s.image} src="//statics.itc.cn/web/v3/static/images/pic/service/pic03.gif" alt="" />
                    </div>
                    <p className={s.label}>北京互联网<br />举报中心</p>
                </LinkWrapper>
                <LinkWrapper className={s.item} href="http://www.bnia.cn/">
                    <div>
                        <img className={s.image} src="//statics.itc.cn/web/v3/static/images/pic/service/pic04.gif" alt="" />
                    </div>
                    <p className={s.label}>北京网络<br />行业协会</p>
                </LinkWrapper>
                <LinkWrapper className={s.item} href="http://www.cyberpolice.cn/">
                    <div>
                        <img className={s.image} src="//statics.itc.cn/web/v3/static/images/pic/service/pic05.gif" alt="" />
                    </div>
                    <p className={s.label}>网络 110<br />报警服务</p>
                </LinkWrapper>
                <LinkWrapper className={s.item} href="http://www.isc.org.cn/">
                    <div>
                        <img className={s.image} src="//statics.itc.cn/web/v3/static/images/pic/service/pic07.gif" alt="" />
                    </div>
                    <p className={s.label}>中国<br />互联网协会</p>
                </LinkWrapper>
                <LinkWrapper className={s.item} href="http://whzf.beijing.gov.cn/bjwhzfhd/accuse.do">
                    <div>
                        <img className={s.image} src="//statics.itc.cn/web/v3/static/images/pic/service/pic08.gif" alt="" />
                    </div>
                    <p className={s.label}>北京文化市<br />场举报热线</p>
                </LinkWrapper>
                <LinkWrapper className={s.item} href="http://www.baom.com.cn/">
                    <div>
                        <img className={s.image} src="//statics.itc.cn/web/v3/static/images/pic/service/pic09.gif" alt="" />
                    </div>
                    <p className={s.label}>首都互联<br />网协会</p>
                </LinkWrapper>
            </div>
            <div className={s.licenseList}>
                <div className={s.list} style={{ width: 329 }}>
                    <p className={s.item}>
                        <LinkWrapper className={s.link} href="http://h5.sohu.com/about/valueAddLicence.html">增值电信业务经营许可证B2-20090148</LinkWrapper>
                        <LinkWrapper className={s.link} href="http://www.sohu.com/upload/uiue20180802/icp.html">京ICP证 030367号</LinkWrapper>
                    </p>
                    <p className={s.item}>
                        <LinkWrapper className={s.link} href="http://www.sohu.com/upload/uiue20171218/web.html">网络文化经营许可证 京网文【2014】0935-235号</LinkWrapper>
                    </p>
                    <p className={s.item}>
                        <LinkWrapper className={s.link} href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11000002000011"><img className={s.police} src="//www.sohu.com/upload/images/server/ghs.png" />京公网安备 11000002000011号</LinkWrapper>
                    </p>
                </div>
                <div className={s.list} style={{ width: 209 }}>
                    <p className={s.item}>
                        <LinkWrapper className={s.link} href="https://www.sohu.com/upload/uiue20200707/vz_sohu.pdf">信息网络传播视听节目许可证</LinkWrapper>
                    </p>
                    <p className={s.item}>
                        <LinkWrapper className={s.link} href="http://www.sohu.com/upload/uiue20180829/xkz_sohu.html">互联网新闻信息服务许可证</LinkWrapper>
                    </p>
                    <p className={s.item}>
                        <LinkWrapper className={s.link} href="http://www.sohu.com/upload/uiue20171218/chubanwu.html">出版物经营许可证</LinkWrapper>
                    </p>
                </div>
                <div className={s.list} style={{ width: 209 }}>
                    <p className={s.item}>
                        <LinkWrapper className={s.link} href="http://py.qianlong.com/">北京地区网站联合辟谣平台</LinkWrapper>
                    </p>
                    <p className={s.item}>
                        <LinkWrapper className={s.link} href="http://www.sohu.com/upload/uiue20171218/chban.html">网络出版服务许可证</LinkWrapper>
                        <LinkWrapper className={s.link} href="http://www.creditchina.gov.cn/">信用中国</LinkWrapper>
                    </p>
                    <p className={s.item}>
                        <LinkWrapper className={s.link} href="//h5.sohu.com/about/beian.html">工商备案公示信息</LinkWrapper>
                    </p>
                </div>
                <div className={s.list} style={{ width: 389 }}>
                    <p className={s.item}>
                        <LinkWrapper className={s.link} href="http://www.sohu.com/upload/uiue20150210/ylbj_sohu.html">互联网医疗保健信息服务复核同意书&nbsp;&nbsp;京卫网审［2014］第0386号</LinkWrapper>
                    </p>
                    <p className={s.item}>
                        <LinkWrapper className={s.link} href="http://www.sohu.com/upload/uiue20171218/ypxx_sohu.html">互联网药品信息服务资格证书 (京)经营性-2014-0013</LinkWrapper>
                    </p>
                    <p className={s.item}>
                        <LinkWrapper className={s.link} href="http://www.sohu.com/upload/uiue20171218/jmzz_sohu.html">广播电视节目制作经营许可证 (京)字第434号</LinkWrapper>
                    </p>
                </div>
            </div>
            <div className={s.hotline}>
                <div className={s.item}>客服投诉热线：010-62726666</div>
                <div className={s.item}>违法和不良信息举报电话：4006809007</div>
                <div className={s.item}>广告投诉电话：4008905505</div>
                <div className={s.item}>客服邮箱：<LinkWrapper href="mailto:kf@vip.sohu.com">kf@vip.sohu.com</LinkWrapper></div>
                <div className={s.item}>举报邮箱：<LinkWrapper href="mailto:jubaosohu@sohu-inc.com">jubaosohu@sohu-inc.com</LinkWrapper></div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/PoliticsFooter/PoliticsFooter.normal.tsx